import {createBrowserClient} from "@supabase/ssr";
import {Database} from "@docid/db/types";
import {getSupabasePublicKey} from "@/utils/supabase/public-key";

export function createClient() {
    return createBrowserClient<Database>(
        process.env.NEXT_PUBLIC_SUPABASE_URL!,
        getSupabasePublicKey()
    )
}
